import {
  RefLinkDetailModal,
  RefLinksTable,
  RPCDocs,
  RPCs,
  usePaginationState,
  useRPC,
} from '@therms/react-modules'
import {useState} from 'react'

type RefType =
  | 'event'
  | 'location'
  | 'location-log-entry'
  | 'record'
  | 'report'
  | 'user'

export interface ViewRefLinksProps {
  forRef: {type: RefType; value: string}
}

function ViewRefLinks({forRef}: ViewRefLinksProps) {
  const [setShowRefLinkDetailModal, setSetShowRefLinkDetailModal] =
    useState<string>()

  const pagination = usePaginationState(`vwrflkpg_${forRef.value}`, [forRef])

  const {data} = useRPC<
    RPCDocs.RefLinks.GetRefLinks.v1.Args,
    RPCDocs.RefLinks.GetRefLinks.v1.Data
  >(RPCs.RefLinks.GetRefLinks.v1, {
    refValue: forRef.value,
  })

  return (
    <>
      {setShowRefLinkDetailModal && (
        <RefLinkDetailModal
          closeHandler={() => setSetShowRefLinkDetailModal(undefined)}
          refLinkId={setShowRefLinkDetailModal}
        />
      )}

      <RefLinksTable
        forRef={forRef}
        onClickRow={setSetShowRefLinkDetailModal}
        refLinksData={data}
        pagination={pagination}
      />
    </>
  )
}

export {ViewRefLinks}
